/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent, CardExtra } from '../../../Shared/Card'
import { CardTitle } from '../../../Shared/CardTitle'
import { Link } from 'react-router-dom-v5-compat'
import { Icon, Image } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

const data = {
    platforms: [
        {
            module: 'ubereats',
            productCount: 12450,
        },
        {
            module: 'deliveroo',
            productCount: 9423,
        },
        {
            module: 'shopify',
            productCount: 2350,
        },
        {
            module: 'justeat',
            productCount: 2350,
        },
    ],
}

const getRandomData = () => {
    return {
        platforms: data.platforms.slice(0, Math.floor(Math.random() * data.platforms.length) + 1),
    }
}

const PublishedProductsCard = () => {
    const [t] = useTranslation()

    const [randomData, setRandomData] = useState(data)

    return (
      <Card
        css={css`
            border-top: 2px solid grey;

            .card-content {
                width: 360px;
                height: 120px;
            }
        `}
      >
          <CardContent>
              <div
                css={css`
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 1rem;
                `}
              >
                  <CardTitle
                    css={css`
                        margin-top: .25rem;
                    `}
                    title={'Produits en ligne'}
                  />
                  <Icon
                    css={css`
                        cursor: pointer;
                    `}
                    name="retweet" onClick={() => {
                      const newData = getRandomData()
                      setRandomData(newData)
                  }}/>
              </div>

              <div
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 80%;
                `}
              >
                  <div
                    css={css`
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(150px, max-content));
                        gap: 1rem;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                    `}
                  >
                      {randomData.platforms.map((platform) => (
                          <div key={platform.module}
                               css={css`
                                   display: flex;
                                   justify-content: flex-start;
                                   align-items: center;
                                   gap: .5rem;
                               `}
                          >
                              <Image
                                src={`/img/platforms/${platform.module}.jpg`}
                                size={randomData.platforms.length > 2 ?
                                  'mini' :
                                  'tiny'
                                }
                              />

                              <strong>{platform.productCount}</strong>
                          </div>
                        ),
                      )}
                  </div>
              </div>
          </CardContent>

          <CardExtra>
              <Link
                to={{
                    pathname: '/categories/publications',
                }}>
                  {t('category_set.manage_link')}
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { PublishedProductsCard }
